import { render, staticRenderFns } from "./DatetimePickerBasic.vue?vue&type=template&id=20e918ce&"
import script from "./DatetimePickerBasic.vue?vue&type=script&lang=js&"
export * from "./DatetimePickerBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports